(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-stage.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-stage.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const tickets = svs.tickets;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const getCampaignTicketType = tickets.next.utils.utils.getCampaignTicketType;
const TicketWithPodiumShadow = tickets.next.components.TicketWithPodiumShadow;
const TicketCarousel = tickets.next.components.ticketCarousel.TicketCarousel;
const PICK_CLOSE_EXIT_DURATION_MS = 360; 
const PICK_ZOOM_EXIT_DURATION_MS = 640; 
const getClassName = function () {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
};
const getTicketAspectRatioValue = ticketInfo => {
  const width = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width);
  const height = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height);
  if (!width || !height) {
    return null;
  }
  return width / height;
};
const getTicketAspectRatio = ticketInfo => {
  const aspectRatioValue = getTicketAspectRatioValue(ticketInfo);
  if (!aspectRatioValue) {
    return null;
  }
  return "".concat(ticketInfo.width, " / ").concat(ticketInfo.height);
};
const isWideTicket = ticketInfo => {
  const aspectRatioValue = getTicketAspectRatioValue(ticketInfo);
  return aspectRatioValue > 1;
};
const getTicketStageStyle = ticketInfo => {
  var _document$documentEle;
  const width = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width);
  const height = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }
  const innerWidth = window.innerWidth || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || 0;
  const playMaxWidth = Math.min(width, innerWidth - 16);
  const growAreaMinHeight = playMaxWidth < innerWidth ? playMaxWidth * (height / width) : height;
  return {
    '--ticket-stage-natural-width': "".concat(width, "px"),
    '--ticket-stage-natural-height': "".concat(height, "px"),
    '--ticket-stage-mobile-max-width': "".concat(Math.min(width, 390), "px"),
    '--ticket-stage-play-max-width': "".concat(playMaxWidth, "px"),
    '--ticket-stage-play-mobile-max-width': "".concat(playMaxWidth, "px"),
    '--ticket-stage-grow-play-min-height': "".concat(growAreaMinHeight, "px")
  };
};
const getCenteredAvailableWidth = _ref => {
  var _boundsNode$getBoundi, _document$documentEle2;
  let boundsNode = _ref.boundsNode,
    node = _ref.node;
  if (typeof window === 'undefined' || !node) {
    return 0;
  }
  const rect = node.getBoundingClientRect();
  const boundsRect = boundsNode === null || boundsNode === void 0 || (_boundsNode$getBoundi = boundsNode.getBoundingClientRect) === null || _boundsNode$getBoundi === void 0 ? void 0 : _boundsNode$getBoundi.call(boundsNode);
  const viewportWidth = window.innerWidth || ((_document$documentEle2 = document.documentElement) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2.clientWidth) || 0;
  const boundsLeft = (boundsRect === null || boundsRect === void 0 ? void 0 : boundsRect.left) || 0;
  const boundsRight = (boundsRect === null || boundsRect === void 0 ? void 0 : boundsRect.right) || viewportWidth;
  const centerX = rect.left + rect.width / 2;
  const sideWidth = Math.max(Math.min(centerX - boundsLeft, boundsRight - centerX), 0);
  return sideWidth * 2;
};
const TicketPodiumStageFrame = _ref2 => {
  let before = _ref2.before,
    children = _ref2.children,
    className = _ref2.className,
    growAreaClassName = _ref2.growAreaClassName,
    growAreaRef = _ref2.growAreaRef,
    holderClassName = _ref2.holderClassName,
    placeholderClassName = _ref2.placeholderClassName,
    placeholderRef = _ref2.placeholderRef,
    placeholderStyle = _ref2.placeholderStyle,
    stageRef = _ref2.stageRef,
    ticketInfo = _ref2.ticketInfo,
    _ref2$opacity = _ref2.opacity,
    opacity = _ref2$opacity === void 0 ? 0.7 : _ref2$opacity;
  svs.tickets.next.hooks.useResizeTick();
  const ticketAspectRatio = getTicketAspectRatio(ticketInfo);
  const ticketStageStyle = getTicketStageStyle(ticketInfo);
  const resolvedPlaceholderStyle = _objectSpread(_objectSpread({}, ticketAspectRatio ? {
    aspectRatio: ticketAspectRatio
  } : null), placeholderStyle);
  return React.createElement("div", {
    className: getClassName('ticket-stage-frame', isWideTicket(ticketInfo) ? 'ticket-stage-frame--wide' : null, className),
    ref: stageRef,
    style: ticketStageStyle
  }, React.createElement("div", {
    className: getClassName('tickets-card-holder tickets-card-holder--play ticket-stage-frame__holder', holderClassName)
  }, before && React.createElement("div", {
    className: "ticket-stage-frame__overlay"
  }, before), React.createElement("div", {
    className: getClassName('tickets-card-grow-area tickets-card-grow-area--play ticket-stage-frame__grow-area', growAreaClassName),
    ref: growAreaRef
  }, React.createElement("div", {
    className: getClassName('tickets-card-placeholder tickets-card-placeholder--play ticket-stage-frame__placeholder', placeholderClassName),
    ref: placeholderRef,
    style: resolvedPlaceholderStyle
  }, children)), React.createElement("div", {
    className: "ticket-stage-frame__podium"
  }, React.createElement(TicketWithPodiumShadow, {
    aspectRatio: ticketAspectRatio,
    opacity: opacity,
    translateY: "12%"
  }))));
};
const useTicketCarouselStageSize = _ref3 => {
  let ticketInfo = _ref3.ticketInfo;
  const growAreaRef = useRef(null);
  const placeholderRef = useRef(null);
  const stageRef = useRef(null);
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    availableWidth = _useState2[0],
    setAvailableWidth = _useState2[1];
  const _useState3 = useState({
      width: 0,
      height: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    panelSize = _useState4[0],
    setPanelSize = _useState4[1];
  useEffect(() => {
    if (!(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.width) || !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.height)) {
      return undefined;
    }
    if (!growAreaRef.current || !placeholderRef.current) {
      return undefined;
    }
    const updateAvailableWidth = () => {
      const nextAvailableWidth = getCenteredAvailableWidth({
        boundsNode: stageRef.current,
        node: placeholderRef.current
      });
      setAvailableWidth(previousAvailableWidth => {
        if (previousAvailableWidth === nextAvailableWidth) {
          return previousAvailableWidth;
        }
        return nextAvailableWidth;
      });
    };
    const removeContainedSizeObserver = svs.tickets.next.utils.utils.observeContainedSize({
      container: growAreaRef.current,
      target: placeholderRef.current,
      width: ticketInfo.width,
      height: ticketInfo.height,
      onUpdate: _ref4 => {
        let width = _ref4.width,
          height = _ref4.height;
        setPanelSize(previousSize => {
          if (previousSize.width === width && previousSize.height === height) {
            return previousSize;
          }
          return {
            width,
            height
          };
        });
        updateAvailableWidth();
      }
    });
    updateAvailableWidth();
    window.addEventListener('resize', updateAvailableWidth);
    let resizeObserver = null;
    if (window.ResizeObserver && placeholderRef.current) {
      resizeObserver = new window.ResizeObserver(updateAvailableWidth);
      resizeObserver.observe(placeholderRef.current);
      if (stageRef.current) {
        resizeObserver.observe(stageRef.current);
      }
    }
    return () => {
      removeContainedSizeObserver();
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener('resize', updateAvailableWidth);
    };
  }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width]);
  return {
    availableWidth,
    growAreaRef,
    panelSize,
    placeholderRef,
    stageRef
  };
};
const useAnimatePickingState = _ref5 => {
  let animatePicking = _ref5.animatePicking,
    animationDoneCallback = _ref5.animationDoneCallback,
    _ref5$options = _ref5.options,
    options = _ref5$options === void 0 ? {
      closeDuration: PICK_CLOSE_EXIT_DURATION_MS,
      zoomDuration: PICK_ZOOM_EXIT_DURATION_MS
    } : _ref5$options;
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    animateCloseCarousel = _useState6[0],
    setAnimateCloseCarousel = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    animateZoomInTicket = _useState8[0],
    setAnimateZoomInTicket = _useState8[1];
  const isMounted = svs.tickets.next.hooks.useIsMounted();
  useEffect(() => {
    if (!animatePicking) {
      return undefined;
    }
    setAnimateCloseCarousel(true);
    const closeCarouselTimeout = window.setTimeout(() => {
      if (!isMounted()) {
        return;
      }
      setAnimateZoomInTicket(true);
    }, options.closeDuration);
    return () => {
      window.clearTimeout(closeCarouselTimeout);
    };
  }, [animatePicking, isMounted, options.closeDuration]);
  useEffect(() => {
    if (!animateZoomInTicket) {
      return undefined;
    }
    const zoomInTicketTimeout = window.setTimeout(() => {
      if (!isMounted()) {
        return;
      }
      animationDoneCallback === null || animationDoneCallback === void 0 || animationDoneCallback();
    }, options.zoomDuration);
    return () => {
      window.clearTimeout(zoomInTicketTimeout);
    };
  }, [animateZoomInTicket, isMounted, animationDoneCallback, options.zoomDuration]);
  return [animateCloseCarousel, animateZoomInTicket];
};
const TicketCarouselStage = _ref6 => {
  var _ticketInfo$skins;
  let _ref6$animatePicking = _ref6.animatePicking,
    animatePicking = _ref6$animatePicking === void 0 ? false : _ref6$animatePicking,
    animationDoneCallback = _ref6.animationDoneCallback,
    _ref6$cssSelectors = _ref6.cssSelectors,
    cssSelectors = _ref6$cssSelectors === void 0 ? 'ticket-with-podium-image' : _ref6$cssSelectors,
    initialSelectedNumber = _ref6.initialSelectedNumber,
    onPick = _ref6.onPick,
    onSelectedNumberChange = _ref6.onSelectedNumberChange,
    ticketInfo = _ref6.ticketInfo,
    ticketType = _ref6.ticketType;
  const _useTicketCarouselSta = useTicketCarouselStageSize({
      ticketInfo
    }),
    availableWidth = _useTicketCarouselSta.availableWidth,
    growAreaRef = _useTicketCarouselSta.growAreaRef,
    panelSize = _useTicketCarouselSta.panelSize,
    placeholderRef = _useTicketCarouselSta.placeholderRef,
    stageRef = _useTicketCarouselSta.stageRef;
  const _useState9 = useState(0.7),
    _useState0 = _slicedToArray(_useState9, 2),
    podiumOpacity = _useState0[0],
    setPodiumOpacity = _useState0[1];
  const _useAnimatePickingSta = useAnimatePickingState({
      animatePicking,
      animationDoneCallback
    }),
    _useAnimatePickingSta2 = _slicedToArray(_useAnimatePickingSta, 2),
    animateCloseCarousel = _useAnimatePickingSta2[0],
    animateZoomInTicket = _useAnimatePickingSta2[1];
  if (!ticketInfo) {
    return null;
  }
  const isCampaignTicket = ticketInfo.type === getCampaignTicketType();
  const className = getClassName('ticket-carousel-stage', animateZoomInTicket ? 'ticket-carousel-stage-animate-picking' : null);
  return React.createElement(TicketPodiumStageFrame, {
    className: className,
    growAreaRef: growAreaRef,
    holderClassName: "ticket-carousel-stage__anchor",
    opacity: podiumOpacity,
    placeholderRef: placeholderRef,
    stageRef: stageRef,
    ticketInfo: ticketInfo
  }, React.createElement("div", {
    className: "ticket-carousel-stage__carousel"
  }, React.createElement(TicketCarousel, {
    animatePicking: animateCloseCarousel,
    availableWidth: availableWidth,
    backImage: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.backImage,
    cssSelectors: cssSelectors,
    image: ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$skins = ticketInfo.skins) === null || _ticketInfo$skins === void 0 || (_ticketInfo$skins = _ticketInfo$skins[0]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image,
    initialSelectedNumber: initialSelectedNumber,
    onPick: onPick,
    onPodiumOpacityChange: setPodiumOpacity,
    onSelectedNumberChange: onSelectedNumberChange,
    panelHeight: panelSize.height,
    panelWidth: panelSize.width,
    skins: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.skins,
    ticketName: (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type),
    ticketPrice: isCampaignTicket && (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price),
    ticketType: (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type) || ticketType,
    variations: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.variations
  })));
};
setGlobal('svs.tickets.next.components.ticketCarousel.TicketPodiumStageFrame', TicketPodiumStageFrame);
setGlobal('svs.tickets.next.components.ticketCarousel.TicketCarouselStage', TicketCarouselStage);

 })(window);